import $ from "jquery";

const question = $(".faq-item .question");
const answer = $(".faq-item .answer");

question.on("click", function () {
  answer.slideUp();
  let clickedAnswer = $(this).siblings(".answer");

  if (clickedAnswer.is(":visible")) {
    clickedAnswer.slideUp();
  } else {
    clickedAnswer.slideDown();
  }
});
